import { Chip, styled } from '@mui/material';

export const TrlPillCanceledStyled = styled(Chip)(({ theme }) => ({
  border: `solid 1px ${theme.palette.colors.pillBorder}`,
  lineHeight: 'normal',
  borderRadius: '8px',
  width: '40px',
  minWidth: '40px',
  height: '14px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  background: theme.palette.gradientes.state.cancel,
  backgroundSize: '7.45px 20.47px',
  justifyContent: 'center',
  '& span': {
    display: 'flex',
    justifyContent: 'center',
  },
  [theme.breakpoints.down('lg')]: {
    width: '56px',
    height: '12px',
  },
}));
